import React, { FunctionComponent, ReactElement } from "react";
import "./styles.scss";
import SurveyDatePicker, { SurveyDatePickerProps } from "./SurveyDatePicker";

export type SurveyFormDatePickerProps = SurveyDatePickerProps & {
  label: string;
  name?: string;
};

export const SurveyFormDatePicker: FunctionComponent<SurveyFormDatePickerProps> = ({
  className,
  label,
  name = "survey-form-select-box",
  ...props
}): ReactElement => {
  return (
    <div className={`survey-datepicker-form-container ${className || ""}`}>
      <label htmlFor={name}>{label}</label>
      <SurveyDatePicker {...props} className="survey-child-timepickerform" />
    </div>
  );
};

export default SurveyFormDatePicker;
